import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { LoadingState, ErrorState, EmptyState } from './osPrimitives';
import { Search, User, ChevronRight } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;
const humanize = (s) => (s || '').toString().replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
const authHeaders = () => { const t = localStorage.getItem('ace_admin_token'); return { ...(t ? { Authorization: `Bearer ${t}` } : {}) }; };
async function getJSON(path) { const r = await fetch(`${API}${path}`, { credentials: 'include', headers: authHeaders() }); if (!r.ok) throw new Error(`${path} ${r.status}`); return r.json(); }

export default function ClientsDirectory() {
  const navigate = useNavigate();
  const [state, setState] = useState({ loading: true });
  const [q, setQ] = useState('');
  useEffect(() => {
    getJSON('/api/crm/clients?limit=200').then((d) => setState({ loading: false, clients: d.clients || [] })).catch(() => setState({ loading: false, error: true }));
  }, []);
  const rows = useMemo(() => {
    const all = state.clients || [];
    const s = q.trim().toLowerCase();
    const filtered = !s ? all : all.filter((c) => [c.name, c.email, c.phone, c.client_id].some((v) => (v || '').toLowerCase().includes(s)));
    return filtered.slice(0, 80);
  }, [state.clients, q]);

  return (
    <div className="os-animate" data-testid="clients-directory">
      <div className="flex items-center gap-2 os-input mb-4" style={{ minHeight: 44, maxWidth: 420 }}>
        <Search className="h-4 w-4" style={{ color: 'var(--os-muted)' }} />
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search clients by name, phone, email…" data-testid="clients-search" className="bg-transparent outline-none text-sm flex-1" style={{ color: 'var(--os-text)' }} />
      </div>
      {state.loading ? <LoadingState rows={5} /> : state.error ? <ErrorState body="Client directory unavailable." />
        : !rows.length ? <EmptyState title="No clients match" />
        : <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-3" data-testid="clients-list">
          {rows.map((c) => <button key={c.client_id} onClick={() => navigate(`/os/clients/${c.client_id}`)} data-testid={`client-row-${c.client_id}`}
            className="os-card p-4 text-left flex items-center justify-between gap-2">
            <div className="min-w-0">
              <p className="font-semibold text-sm truncate" style={{ color: 'var(--os-text)' }}>{c.name || 'Client'}</p>
              <p className="text-xs truncate" style={{ color: 'var(--os-muted)' }}>{[c.client_id, c.phone, c.email].filter(Boolean).join(' · ')}</p>
              <p className="text-[11px] mt-0.5" style={{ color: 'var(--os-muted)' }}>{humanize(c.segment) || 'General'} · {c.total_bookings || 0} services</p>
            </div>
            <ChevronRight className="h-4 w-4 shrink-0" style={{ color: 'var(--os-muted)' }} />
          </button>)}
        </div>}
    </div>
  );
}
